import styled from 'styled-components';
import { applyElevation, themeGet } from '@packages/ui';

export type ArrowProps = {
  className?: string;
};

export const Arrow = styled.button`
  ${applyElevation};
  cursor: pointer;
  background-color: ${themeGet.colors('primary')};
  height: 41px;
  width: 34px;
  padding: 0;
  border: none;

  color: ${themeGet.colors('white')};

  &:hover:not([disabled]) {
    box-shadow: 0px 0px 7px 3px rgba(0, 0, 0, 0.2);
  }
  &:active {
    background-color: #cb5938;
  }
  &:disabled {
    background-color: ${themeGet.colors('silver')};
  }
`;
